import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { getDummyTestimonialList,submitTemplate,updateTemplateDetail } from "../../../../utils/testimonialsApi";
import '../../../../assets/css/app-testimonials-module.css';
import '../../../../assets/css/loader.css';

//Import Widgets
/*import SliderTemplateWidget from "../../../../components/Apps/Testimonials/Template/SliderWidget";
import RotatorTemplateWidget from "../../../../components/Apps/Testimonials/Template/RotatorWidget";
import CarouselTemplateWidget from "../../../../components/Apps/Testimonials/Template/CarouselWidget";
import CardsTemplateWidget from "../../../../components/Apps/Testimonials/Template/CardsWidget";
import DarkCarouselTemplateWidget from "../../../../components/Apps/Testimonials/Template/DarkCarouselWidget";
import CustomerStoryTemplateWidget from "../../../../components/Apps/Testimonials/Template/CustomerStoryWidget";*/
import DynamicTemplate from "../../../../components/Apps/Testimonials/Template/DynamicTemplate";

//Import Tabs
import ContentTab from "../../../../components/Apps/Testimonials/ContentTab";
import LayoutTab from "../../../../components/Apps/Testimonials/LayoutTab";
import TestimonialTab from "../../../../components/Apps/Testimonials/TestimonialTab";
import StyleTab from "../../../../components/Apps/Testimonials/StyleTab";
import SettingTab from "../../../../components/Apps/Testimonials/SettingTab";

export default function CreateTestimonials() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Slider_Temp");
    const [selectedLayout, setSelectedLayout] = useState("slider_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("slider.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Testimonials Slider");
    const [newWidgetName, setNewWidgetName] = useState("");
    const [isTemplateId, setIsTemplateId] = useState(null);
    const [isTestimonialIds, setIsTestimonialIds] = useState([]);
    const [isScrolled, setIsScrolled] = useState(false);
    const [testimonialTabData, setTestimonialTabData] = useState({
        is_website_frontend: "", 
        layout_columns: "Auto",
        layout_items_per_page: 3,    
        layout_items_per_page_on_mobile: 3,    
        layout_item_spacing: 10,    
        layout_is_show_load_more_button: 1,    
        layout_is_full_width: 1,    
        layout_custom_width: "auto",    
        layout_is_widget_title: 1,    
        layout_widget_title_name: "What our clients say",    
        layout_widget_caption_name: "",    
        testimonial_style: "",    
        testimonial_is_show_reviewer_name: 1,    
        testimonial_is_show_verified_badge: 1,    
        testimonial_is_show_reviewer_picture: 1,    
        testimonial_is_show_caption: 1,    
        testimonial_is_show_date: 1,    
        testimonial_is_show_rating: 1,    
        testimonial_is_show_images: 1,    
        testimonial_is_show_logo: 1,    
        testimonial_show_reviewer_name: "John Smith",    
        testimonial_how_to_display_review_text_type: "",    
        testimonial_preview_text_length: "",    
        testimonial_is_align_cards_by_height: "",    
        style_color_scheme_type: "",    
        style_font_type: "",    
        style_background_color: "#fff",    
        style_widget_title_alignment: "",    
        style_colors_title_color: "#000",    
        style_colors_caption_color: "#000",     
        style_colors_links_color: "#000",    
        style_colors_font_title_size: "14",    
        style_colors_font_caption_size: "14",    
        style_rating_color: "#FFFF00",    
        style_testimonial_background_color: "#fff",    
        style_testimonial_testimonial_outline_color: "",    
        style_testimonial_testimonial_text_color: "#000",    
        style_testimonial_read_more_color: "#fff",    
        style_testimonial_reviewer_name_color: "#000",    
        style_testimonial_verified_badge_color: "#197BFF",    
        style_testimonial_caption_color: "#000",    
        style_testimonial_website_url_color: "",    
        style_testimonial_rating_sizetype: ['Medium'],    
        style_testimonial_testimonial_text_font_size: "14", 
        style_testimonial_custom_css: "",       
        settings_language_type: "",    
        settings_language_text_overall_rating: "",    
        settings_language_text_load_more: "",    
        settings_language_text_read_more: "",    
        settings_language_text_hide: "",       
        settings_language_text_verified_customer: "",    
        settings_language_text_read_our_number_testimonials: "",    
        settings_language_text_based_on_number_testimonials: "",    
        settings_language_text_view_on: "",    
        settings_is_enable_schema_org_markup: "",    
        settings_sorting_type: "",    
        settings_is_open_links_in_new_tab: 1,    
        settings_custom_js: "",    
    });

    // Set Template Setting And Texts when activeTemplateSection changes
    useEffect(() => {
        let style_background_color = "";
    
        switch (activeTemplateSection) {
            case "Slider_Temp":
                style_background_color = "#fff";
                break;
            case "Rotator_Temp":
                style_background_color = "#fff";
                break;
            case "Carousel_Temp":
                style_background_color = "#fff";
                break;
            case "Cards_Temp":
                style_background_color = "#fff";
                break;
            case "Dark_Carousel_Temp":
                style_background_color = "#fff";
                break;
            case "Customer_Story_Temp":
                style_background_color = "#fff";
                break;
            default:
                style_background_color = "#fff";
        }
    
        // Update setTestimonialTabData state with the data
        setTestimonialTabData((prevData) => ({
            ...prevData,
            style_background_color: style_background_color,
            
        }));
    
    }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateTestimonialTabData = (key, value) => {
        setTestimonialTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = async () => {
        setShowTemplateSelection(false);
        
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            setSelectedLayout(layoutTypeValue);
        } else {
            alert('Please select a template');
        }

        //Call Api To Create Templates with dummy data first
        try {
            // Collect data from refs
            const settingsArray = Object.entries(testimonialTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "Testimonial_Slider",
                testimonial_ids: isTestimonialIds,
                settings: settingsArray,
            };
            
            //Api Call
            let api_response = await submitTemplate(payload);
            //Check Responce
            if (api_response.status === true) {
                setIsTemplateId(api_response.data.template_id);
                setIsTestimonialIds(api_response.data.testimonial_ids);
                setIsSubmitting(false);
            } 
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    }; 

    const menuItems = [
        { key: "Content", icon: "content.png", label: "Content" },
        { key: "Layout", icon: "layout.png", label: "Layout" },
        { key: "Testimonial", icon: "testimonial.png", label: "Testimonial" },
        { key: "Style", icon: "style.png", label: "Style" },
        { key: "Settings", icon: "setting.png", label: "Settings" },
    ];

    // Handle Source Tab input change
    const handleActiveTemplateInputChange = async (event) => {
        setActiveTemplateSection(event.target.value);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            const template_image = selectedRadio.dataset.template_image;
            setSelectedLayout(layoutTypeValue);
            setSelectedTemplateImage(template_image);
        } else {
            alert('Please select a template');
        }
    };


    // Handle Layout Change
    const handleLayoutChange = (e) => {
        setSelectedLayout(e.target.value);
    };
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const templateResult = await getDummyTestimonialList();
                if (templateResult?.status === true && templateResult?.data?.testimonial_list) {
                    // Extracting template IDs properly
                    const templateIds = templateResult.data.testimonial_list.map(testimonial => testimonial.id);
                    setIsTestimonialIds(templateIds);
                } else {
                    setIsTestimonialIds([]);
                }
            } catch (error) {
                //console.error("Error fetching data:", error);
            } 
        };
        fetchData();
    }, []);

    //Update Form data
    const updateForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            // Convert settings object back into an array of key-value pairs
            const updateSettingsArray = Object.entries(testimonialTabData).map(([key, value]) => ({
                setting_key: key,
                setting_value: value,
            }));

            // Collect data from refs
            const payload = {
                template_id: isTemplateId,
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                testimonial_ids: isTestimonialIds,
                settings: updateSettingsArray,
            };
            
            //Api Call
            let api_response = await updateTemplateDetail(payload);

            //Check Responce
            if (api_response.status === true) {
                toast.success("Submitted Successfully.");
                  // Redirect after 2 seconds
                  setTimeout(() => {
                      navigate('/customer/apps/testimonials');
                  }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Testimonials Slider" app_type="Testimonial_Slider" app_slug="testimonials"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Slider_Temp" data-layout_type="slider_layout" data-template_image="slider.png" checked={activeTemplateSection === "Slider_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/testimonials/templates/slider.png`} alt="slider" />
                                    </div>
                                    <div className="content_sub">Slider</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Rotator_Temp" data-layout_type="slider_layout" data-template_image="rotator.png" checked={activeTemplateSection === "Rotator_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/testimonials/templates/rotator.png`} alt="rotator" />
                                    </div>
                                    <div className="content_sub">Rotator</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Carousel_Temp" data-layout_type="carousel_layout" data-template_image="carousel.png" checked={activeTemplateSection === "Carousel_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/testimonials/templates/carousel.png`} alt="carousel" />
                                    </div>
                                    <div className="content_sub">Carousel</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Cards_Temp" data-layout_type="grid_layout" data-template_image="cards.png" checked={activeTemplateSection === "Cards_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/testimonials/templates/cards.png`} alt="cards" />
                                    </div>
                                    <div className="content_sub">Cards</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Dark_Carousel_Temp" data-layout_type="carousel_layout"  data-template_image="dark-carousel.png" checked={activeTemplateSection === "Dark_Carousel_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/testimonials/templates/dark-carousel.png`} alt="dark-carousel" />
                                    </div>
                                    <div className="content_sub">Dark Carousel</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Customer_Story_Temp" data-layout_type="slider_layout" data-template_image="customer-story.png" checked={activeTemplateSection === "Customer_Story_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/testimonials/templates/customer-story.png`} alt="customer-story" />
                                    </div>
                                    <div className="content_sub">Customer Story</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/testimonials/icons//${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab isTemplateId={isTemplateId} updateTestimonialTabData={updateTestimonialTabData} testimonialTabData={testimonialTabData} templateType={activeTemplateSection}/>
                            )}
                            {activeSection === "Layout" && (
                              <LayoutTab handleLayoutChange={handleLayoutChange} selectedLayout={selectedLayout} updateTestimonialTabData={updateTestimonialTabData} testimonialTabData={testimonialTabData}/>
                            )}
                            {activeSection === "Testimonial" && (
                              <TestimonialTab updateTestimonialTabData={updateTestimonialTabData} testimonialTabData={testimonialTabData}/>
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updateTestimonialTabData={updateTestimonialTabData} testimonialTabData={testimonialTabData}/>
                            )}
                            {activeSection === "Settings" && (
                              <SettingTab updateTestimonialTabData={updateTestimonialTabData} testimonialTabData={testimonialTabData}/>
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper">
                    <div class={`source-header-row ${isScrolled ? "scrolled" : ""}`}>
                        <h2><Link to="/customer/apps/testimonials"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name testimonal-icon">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/images/app-icon/testimonial-color.svg`} alt="app-icon-5"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={updateForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/testimonials/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/testimonials" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Testimonials Slider <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Slider_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} isTemplateId={isTemplateId} testimonialTabData={testimonialTabData}/>
                    )}

                    {activeTemplateSection === "Rotator_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} isTemplateId={isTemplateId} testimonialTabData={testimonialTabData}/>
                    )}

                    {activeTemplateSection === "Carousel_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} isTemplateId={isTemplateId} testimonialTabData={testimonialTabData}/>
                    )}

                    {activeTemplateSection === "Cards_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} isTemplateId={isTemplateId} testimonialTabData={testimonialTabData}/>
                    )}

                    {activeTemplateSection === "Dark_Carousel_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} isTemplateId={isTemplateId} testimonialTabData={testimonialTabData}/>
                    )}

                    {activeTemplateSection === "Customer_Story_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} selectedLayout={selectedLayout} isTemplateId={isTemplateId} testimonialTabData={testimonialTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 